import React from "react";
import { Container, Grid } from "semantic-ui-react";
const NoData = ({
  message = "No data available"
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: "no-data"
  }, /*#__PURE__*/React.createElement(Grid, {
    columns: 1,
    className: "no-data-wrapper"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    textAlign: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement("img", {
    className: "no-data-icon",
    src: "/icon_no_data.svg",
    alt: "No data icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "no-data-message"
  }, message))));
};
export default NoData;